<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pjOun2/tc-custom/9781439677780.jpg?1704886585285" alt="This image is the cover for the book Civilian Conservation Corps Cookbook"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Civilian Conservation Corps Cookbook
      </h1>
      <p class="bookDescription body article font2">
        <p>The Civilian Conservation Corps was a voluntary government work relief program that offered nearly 3 million unemployed, unmarried men the job of restoring and conserving America's public lands, forests and parks. The wages weren't the only draw--the program also threw in three square meals a day served in the camp mess hall. The Civilian Conservation Corps Cookbook features the recipes that sustained not only the CCC during the Great Depression but also our grandparents and great-grandparents. Budget friendly, with ingredients that can easily be found--if not in your very own pantry then at your local grocer--these recipes reflect the "make do" attitude of Depression-era home cooks.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amy Bizzarri
      </h2>
      
      <p class="authorDescription body article">Amy Bizzarri has written four books focused on Chicago history, but her experiences don't stop there. She's a teacher, tour guide, and certified wine expert. When she's not exploring her beloved Chicago by bicycle, you'll find her hiking the trails of a state or national park. Oh, yes, she's a mermaid, too, having trained with the celebrated sirens at Florida's Weeki Wachee Springs. Follow Amy's latest adventures at instagram.com/amybizzarri.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d340c93